"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class Transaction {
  static thaw(transactionObj) {
    if (transactionObj == null) return null;
    const transaction = new Transaction();
    if (transactionObj.id != null) transaction.setId(transactionObj.id);
    if (transactionObj.stripeId != null) transaction.setStripeId(transactionObj.stripeId);
    if (transactionObj.amount != null) transaction.setAmount(transactionObj.amount);
    if (transactionObj.status != null) transaction.setStatus(transactionObj.status);
    if (transactionObj.type != null) transaction.setType(transactionObj.type);
    if (transactionObj.owedByGroupId != null) transaction.setOwedByGroupId(transactionObj.owedByGroupId);
    if (transactionObj.owedByGroup != null) transaction.setOwedByGroup(_.Group.thaw(transactionObj.owedByGroup));
    if (transactionObj.owedById != null) transaction.setOwedById(transactionObj.owedById);
    if (transactionObj.owedBy != null) transaction.setOwedBy(_.Person.thaw(transactionObj.owedBy));
    return transaction;
  }

  static thawList(transactionObjList) {
    if (transactionObjList == null) return [];
    var transactions = [];

    for (var i = 0; i < transactionObjList.length; i++) {
      transactions.push(Transaction.thaw(transactionObjList[i]));
    }

    return transactions;
  }

  static freeze(transaction) {
    if (transaction == null) return null;
    var transactionObj = {};
    if (transaction.getId() != null) transactionObj.id = transaction.getId();
    if (transaction.getStripeId() != null) transactionObj.stripeId = transaction.getStripeId();
    if (transaction.getAmount() != null) transactionObj.amount = transaction.getAmount();
    if (transaction.getStatus() != null) transactionObj.status = transaction.getStatus();
    if (transaction.getType() != null) transactionObj.type = transaction.getType();
    if (transaction.getOwedByGroupId() != null) transactionObj.owedByGroupId = transaction.getOwedByGroupId();
    if (transaction.getOwedByGroup() != null) transactionObj.owedByGroup = transaction.getOwedByGroup();
    if (transaction.getOwedById() != null) transactionObj.owedById = transaction.getOwedById();
    if (transaction.getOwedBy() != null) transactionObj.owedBy = transaction.getOwedBy();
    return transactionObj;
  }

  static freezeList(transactions) {
    if (transactions == null) return [];
    var transactionObjList = [];

    for (var i = 0; i < transactions.length; i++) {
      transactionObjList.push(Transaction.freeze(transactions[i]));
    }

    return transactionObjList;
  }

  constructor() {
    this.setId(null);
    this.setStripeId(null);
    this.setAmount(null);
    this.setStatus(null);
    this.setType(null);
    this.setOwedByGroupId(null);
    this.setOwedByGroup(null);
    this.setOwedById(null);
    this.setOwedBy(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setStripeId(stripeId) {
    this.stripeId = stripeId;
  }

  setAmount(amount) {
    this.amount = amount;
  }

  setStatus(status) {
    this.status = status;
  }

  setType(type) {
    this.type = type;
  }

  setOwedByGroupId(owedByGroupId) {
    this.owedByGroupId = owedByGroupId;
  }

  setOwedByGroup(owedByGroup) {
    this.owedByGroup = owedByGroup;
  }

  setOwedById(owedById) {
    this.owedById = owedById;
  }

  setOwedBy(owedBy) {
    this.owedBy = owedBy;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getStripeId() {
    return this.stripeId;
  }

  getAmount() {
    return this.amount;
  }

  getStatus() {
    return this.status;
  }

  getType() {
    return this.type;
  }

  getOwedByGroupId() {
    return this.owedByGroupId;
  }

  getOwedByGroup() {
    return this.owedByGroup;
  }

  getOwedById() {
    return this.owedById;
  }

  getOwedBy() {
    return this.owedBy;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = Transaction;